import store from "@/store"
import { getAIConfig } from "@/views/js"

export const showArticleChat = () => {
    return store.getters.AIConfig.articleChat
}
export const showWebSearch=()=>{

       return store.getters.AIConfig.webSearch
 


}
export const showReportLibrary=()=>{

    return store.getters.AIConfig.reportLibrary
}

export const showAIknowledge=(companyType,companyId)=>{
    if(companyId==834) return false
    else return true
    //  if(companyType==2) return true
    // else{
    //     // var companyIdList=[782,820,789,793,843,331,846,750,32,803,825,828,848,849]
    //     return store.getters.AIConfig.torchVApp
    //  }


}
export const toGetAIConfig=(company)=>{
   
   return new Promise((resolve, reject) => {

    if(company.companyId){
        getAIConfig({id:company.companyId}).then((res) =>{
    
            store.dispatch('AIConfig',{webSearch:res.data.webSearch||false,articleChat:res.data.articleChat||false,reportLibrary:res.data.reportLibrary||false})
            resolve()
         })
     }
     else  resolve()
   })
}